"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  automaticLinker: null,
  botFilteringEnabled: null,
  cookiesToSubdomain: null,
  crossDomainTracking: null,
  domain: null,
  includeEnterpriseJs: null,
  ipFilters: '',
  limitTrackingToCookieDomains: null,
  policyOverrides: [],
  privacyAcceptWording: null,
  privacyBannerAccentColor: null,
  privacyBannerType: null,
  privacyDisclaimerWording: null,
  privacyDismissWording: null,
  privacyHideDecline: null,
  privacyMode: null,
  privacyPolicy: null,
  privacyPolicyWording: null,
  referrerFilters: '',
  timezone: null,
  weeklyStartsOnMonday: null
}, 'ReportsSettings');

exports.default = _default;
module.exports = exports.default;